import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { Headline, BodyCopy } from '@xingternal/typography';
import { Button } from '@xingternal/button';
import { Grid, Column, Row } from '@xingternal/xing-grid';

import styles from './successPage.css';

import { resetSubmission as resetSubmissionAction } from '../state/actions';

const hostname = (global.location && global.location.host) || 'www.xing.com';

class Success extends Component {
  componentDidMount() {
    const { submitSuccess, resetSubmission, history } = this.props;

    if (submitSuccess) {
      resetSubmission();
    } else {
      history.replace('/support/contact');
    }
  }

  text() {
    const { emailAttached, email } = this.props;

    return (
      <span>
        <FormattedMessage id="CONTACT_FORM_OKAY" />
        {emailAttached && (
          <span>
            <br />
            <br />
            <FormattedMessage
              id="CONTACT_FORM_CONFIRM_NEW_EMAIL_ADDRESS"
              tagName="span"
              values={{
                strong: (chunks) => <strong>{chunks}</strong>,
                br: () => <br />,
                email,
              }}
            />
          </span>
        )}
      </span>
    );
  }

  render() {
    return (
      <Grid className={styles.successCard}>
        <Row>
          <Column size={12}>
            <Headline size="xxlarge">
              <center>
                <FormattedMessage id="CONTACT_FORM_THANKS" />
              </center>
            </Headline>
          </Column>
        </Row>
        <Row>
          <Column size={12}>
            <center>
              <BodyCopy>{this.text()}</BodyCopy>
            </center>
          </Column>
        </Row>
        <Row>
          <Column size={12}>
            <center>
              <Button
                variant="primary"
                size="small"
                onClick={() => {
                  window.location = `http://${hostname}`;
                }}
              >
                <FormattedMessage id="CONTACT_FORM_TO_STARTPAGE" />
              </Button>
            </center>
          </Column>
        </Row>
      </Grid>
    );
  }
}

Success.defaultProps = {
  resetSubmission: () => {},
  emailAttached: false,
  email: '',
  history: {
    replace: () => {},
  },
};

Success.propTypes = {
  submitSuccess: PropTypes.bool.isRequired,
  resetSubmission: PropTypes.func,
  emailAttached: PropTypes.bool,
  email: PropTypes.string,
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
  }),
};

const mapStateToProps = ({
  contact: {
    submitSuccess,
    emailAttached,
    fields: { email },
  },
}) => ({
  submitSuccess,
  emailAttached,
  email,
});

export { Success };
export default connect(mapStateToProps, { resetSubmissionAction })(withRouter(Success));
